
  import { defineComponent, onMounted, ref } from 'vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { ContactusObject } from '@/store/modules/Settings/ContactusModule';
  import { useAbility } from '@casl/vue';

  export default defineComponent({
    name: 'Contact-us-overview',
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const { can } = useAbility();

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('contactUsOverview'), [
          translate('settings'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_CONTACT,
        route.params.id
      );

      const contactUs = ref<ContactusObject>(data.data);

      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        translate,
        can,
        contactUs,
      };
    },
  });
